module.exports = __webpack_public_path__ + "img/zgcls.2a714a10.png";